<ng-container *ngIf="product$ | async as product">
  <app-product-view [productId]="product.id"></app-product-view>
</ng-container>
